module.exports = __webpack_public_path__ + "static/media/theme_4.26b42ff5.jpg";